import { Button, Modal } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import { useDispatch } from "react-redux";
import { GetAllClaimsList, MultipleResubmitClaim } from "../config/cliamApi";
const ResubmitMultipleclaimModal = ({
  setShowResubmitFailedModal,
  show,
  onClose,
  claims,
  status,
  description,
  setShowSuccessModal,
  setResubmitData,
  body,
  setPage,
  setRowsPerPage,
}) => {
  const dispatch = useDispatch();
  const resubmitClaims = async () => {
    const requestBody = {
      claim_data: claims?.map((claim) => ({
        claimid: claim.claimfull_id,
        claim_type: claim.claim_type,
        claim_status: claim?.claim_status,
      })),
    };

    const response = await dispatch(
      MultipleResubmitClaim(requestBody)
    ).unwrap();
    if (response?.success) {
      setShowSuccessModal(true);
      setShowResubmitFailedModal(false);
      onClose();
      setPage(0);
      setRowsPerPage(10);
      await dispatch(GetAllClaimsList(body)).unwrap();
    } else {
      //   return;
      setShowResubmitFailedModal(true);
      setShowSuccessModal(false);
      setResubmitData(response);
      onClose();
    }
  };
  return (
    <Modal show={show} centered dialogClassName="wizard-modal" size="lg">
      <Modal.Body>
        <FalconCloseButton
          onClick={onClose}
          size="sm"
          className="position-absolute top-0 end-0 me-2 mt-2"
        />
        <Flex direction="column" alignItems="center" className="mb-3">
          <h6 className="fs-8 text-capitalize text-700">
            {status === "withdrawn" ? "withdraw" : status} Claims
          </h6>
          <h6 className="text-center text-700">{description}</h6>
          <h6 className="fs-10 text-600 text-center">
            Are you sure you want to{" "}
            {status === "withdrawn" ? "withdraw" : status}{" "}
            <span className="text-danger">{claims?.length}</span> claims?
          </h6>
        </Flex>

        <hr />
        <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
          <Button variant="danger" size="sm" onClick={onClose}>
            No
          </Button>
          <Button variant="success" size="sm" onClick={resubmitClaims}>
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ResubmitMultipleclaimModal;
